import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextDiaT2 = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Type 2 diabetes is a common condition that causes the level of sugar (glucose) in the blood to become too high.
It can cause symptoms like excessive thirst, needing to pee a lot and tiredness. It can also increase your risk of getting serious problems with your eyes, heart and nerves.
It's a lifelong condition that can affect your everyday life. You may need to change your diet, take medicines and have regular check-ups.
It's caused by problems with a chemical in the body (hormone) called insulin. It's often linked to being overweight or inactive, or having a family history of type 2 diabetes.
<br /> <br /> 
Many people have type 2 diabetes without realising. This is because symptoms do not necessarily make you feel unwell.

Symptoms of type 2 diabetes include:
<br /> <br /> 
peeing more than usual, particularly at night<br /> 
feeling thirsty all the time<br /> 
feeling very tired<br /> 
losing weight without trying to<br /> 
itching around your penis or vagina, or repeatedly getting thrush<br /> 
cuts or wounds taking longer to heal<br /> 
blurred vision<br /> <br /> 
You're more at risk of developing type 2 diabetes if you:<br /> <br /> 

are over 40 (or 25 for south Asian people)<br /> 
have a close relative with diabetes (such as a parent, brother or sister)<br /> 
are overweight or obese
 <br /> <br /> 
 Metformin is the most common medicine for type 2 diabetes. It can help keep your blood sugar at a healthy level.

It comes as tablets you take with or after meals.

Common side effects of metformin include feeling or being sick and diarrhoea. If this happens to you, your doctor may suggest trying a different type called slow-release metformin.<br /> <br /> 
 
<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
'HLA-DR', 'HLA-DR2', 'HLA-DR3', 'HLA-DR4' 'HLA-DQ', 'HLA-DP', 'DQB1', 'DRB1', 'ZFM1', 'FADD', 'FAS', 'LRP5', 'SOD2', 'DCC', 'ZNF236', 'NEUROD1', 'MODY6', 'IGRP', 'GAD', 'GAD2',
 'GABA', 'KIR', 'ABCC8', 'SEL1L', 'CTLA4', 'CD28', 'ICOS', 'ILB12'  
 
<br /><br /> 
 
</Typography>

</div>
)
}